/* ORYA Pure — countdown to Tuesday 23:59 Europe/Rome.
   Lives as a theme asset (assets/orya-countdown.js) so store CSP allows it. */
(function () {
  function boot() {
    var root = document.getElementById('orya-countdown');
    if (!root) { return setTimeout(boot, 300); }
    if (root.getAttribute('data-orya-init')) { return; }
    root.setAttribute('data-orya-init', '1');

    var eD = root.querySelector('[data-days]'),
        eH = root.querySelector('[data-hours]'),
        eM = root.querySelector('[data-mins]'),
        eS = root.querySelector('[data-secs]');

    function romeNow() {
      return new Date(
        new Date().toLocaleString('en-US', { timeZone: 'Europe/Rome' })
      );
    }

function nextWed() {
  var r = romeNow(),
      d = r.getDay(),
      t = new Date(r),
      u = (3 - d + 7) % 7;

  t.setDate(r.getDate() + u);
  t.setHours(23, 59, 59, 999);

  if (t.getTime() <= r.getTime()) {
    t.setDate(t.getDate() + 7);
  }

  return t;
}

    var dl = nextWed();

    function p(n) {
      return (n < 10 ? '0' : '') + n;
    }

    function tick() {
      var r = romeNow(),
          diff = dl.getTime() - r.getTime();

      if (diff <= 0) {
        dl = nextWed();
        diff = dl.getTime() - r.getTime();
      }

      var s = Math.floor(diff / 1000);

      eD.textContent = p(Math.floor(s / 86400));
      eH.textContent = p(Math.floor((s % 86400) / 3600));
      eM.textContent = p(Math.floor((s % 3600) / 60));
      eS.textContent = p(s % 60);
    }

    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();